module.exports = __webpack_public_path__ + "img/9.992a51a0.webp";